import { Breakpoint } from "react-socks"
import Img from "gatsby-image"
import PropTypes from "prop-types"
import React from "react"
// import Slider from "react-slick"
import { Link } from "gatsby"

import {
  SimpleFeature,
  PremiumFeature,
  YekanParagraph,
  FontIcon,
} from "../typography"
import { ListContainer, ListItem, ListFlex } from "./styled"
import { Button } from "../inputs"
import { colors } from "../../utils/styleVariables"

const FeatureInner = ({
  secondary,
  premium,
  fixed,
  image,
  title,
  description,
  slug,
}) => {
  const linkTo = `/why-kamva#${slug}`
  return (
    <ListFlex valign="center" premium={premium}>
      {fixed && premium && (
        <Img style={{ margin: "0 auto 32px" }} fixed={fixed} alt={image} />
      )}
      <Link className="list-title" to={premium ? "/features" : linkTo}>
        {secondary ? (
          <SimpleFeature>{title}</SimpleFeature>
        ) : (
          <PremiumFeature>{title}</PremiumFeature>
        )}
      </Link>
      <Breakpoint laptop up>
        {description && (
          <YekanParagraph
            dangerouslySetInnerHTML={{ __html: description }}
          ></YekanParagraph>
        )}
      </Breakpoint>
      {slug && !premium && (
        <>
          <Breakpoint tablet up>
            <Button
              text="بیشتر"
              to={linkTo}
              backgroundColor={[...colors.coral, "0.3"]}
              color={colors.coral}
            />
          </Breakpoint>
          <Breakpoint mobile down>
            <Link
              className="more"
              to={linkTo}
              style={{ display: "inline-block", textDecoration: "none" }}
            >
              <FontIcon fontSize="2rem">
                <span className={`icon-goto`} />
              </FontIcon>
            </Link>
          </Breakpoint>
        </>
      )}
    </ListFlex>
  )
}

class FeatureList extends React.Component {
  constructor() {
    super()
    this.state = {
      proceed: false,
    }
  }
  componentDidMount() {
    this.setState({
      proceed: true,
    })
  }
  render() {
    const { items, images, perRow, premium, secondary } = this.props
    const { proceed } = this.state

    const widths = [0, 1, 2, 3, 4].reduce((acc, p) => {
      const text = p => `${100 / p}%`
      const v = perRow[p] ? text(perRow[p]) : acc[p - 1]

      return [...acc, v]
    }, [])

    const imageNames = images
      ? images.map(o => {
          const image = o["image"]["fixed"]["originalName"]
          return image.split(".")[0]
        })
      : []

    // const settings = {
    //   rtl: true,
    //   arrows: false,
    //   slidesToShow: 1.5,
    // }
    const allItems = items.map(({ image, title, description, slug }, i) => {
      const index = imageNames.findIndex(o => o === image)
      const fixed = images && index !== -1 && images[index].image.fixed
      return (
        <ListItem widths={widths} key={`${title}_${i}`}>
          {premium ? (
              <FeatureInner
                premium={true}
                secondary={secondary}
                image={image}
                title={title}
                description={description}
                fixed={fixed}
                slug={slug}
              />
          ) : (
            <FeatureInner
              secondary={secondary}
              image={image}
              title={title}
              description={description}
              fixed={fixed}
              slug={slug}
            />
          )}
        </ListItem>
      )
    })
    if (proceed) {
      return (
        <ListContainer>{allItems}</ListContainer>
        // <>
        //   <Breakpoint tablet up>
        //   </Breakpoint>
        //   <Breakpoint mobile down>
        //     <Slider {...settings}>{allItems}</Slider>
        //   </Breakpoint>
        // </>
      )
    }
    return null
  }
}

FeatureList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
    })
  ),
  perRow: PropTypes.arrayOf(PropTypes.number),
  images: PropTypes.array,
  premium: PropTypes.bool,
  secondary: PropTypes.bool,
}

FeatureList.defaultProps = {
  perRow: [4],
}

export default FeatureList
